import { useEffect } from 'react';

// Global counter to track how many components have requested a scroll lock
let lockCount = 0;
let originalBodyOverflow = '';
let originalHtmlOverflow = '';

/**
 * Hook to lock body scroll when a modal or overlay is open.
 * Uses a global counter to handle multiple nested/simultaneous modals.
 */
export const useScrollLock = (isOpen: boolean) => {
    useEffect(() => {
        if (!isOpen) return;

        // If this is the first lock, save original styles
        if (lockCount === 0) {
            originalBodyOverflow = window.getComputedStyle(document.body).overflow;
            originalHtmlOverflow = window.getComputedStyle(document.documentElement).overflow;
            
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        }
        
        lockCount++;

        // Cleanup: decrement counter and restore if it reaches zero
        return () => {
            lockCount--;
            if (lockCount <= 0) {
                lockCount = 0; // Safety reset
                document.body.style.overflow = originalBodyOverflow;
                document.documentElement.style.overflow = originalHtmlOverflow;
            }
        };
    }, [isOpen]);
};
